// Booking and contact constants
export const BOOKING_URL = "https://salonkee.de/salon/hair-beauty-nava";

export const STUDIO = {
  name: "Hair & Beauty Nava",
  shortName: "Nava",
  tagline: "Friseur · Kosmetik",
  city: "Frankfurt",
};

export const CONTACT = {
  address: "Hainer Weg 146, 60599 Frankfurt am Main",
  phone: "+49 1575 9436804",
  phoneLink: "+4915759436804",
  hairPhone: "+49 177 1815027",
  hairPhoneLink: "+491771815027",
  hairWhatsAppLink: "https://wa.me/491771815027",
  hours: [
    { day: "Mo – Do", time: "09:00 – 19:00" },
    { day: "Fr – So", time: "Geschlossen" },
  ],
};

// Service catalog organized into 6 categories
export const SERVICE_CATEGORIES = [
  {
    id: "angebote",
    title: "Angebote & Pakete",
    subtitle: "Exklusive Behandlungs-Serien",
    badge: "Featured",
    items: [
      { name: "Fruchtsäurepeeling — 4er Paket", price: "285 €" },
      { name: "Microdermabrasion — 4er Paket", price: "255 €" },
      { name: "Wellness Beauty Paket (Maniküre + Pediküre + Gesicht)", price: "100 €" },
      { name: "Wohlfühlzeit für Männer", price: "100 €" },
    ],
  },
  {
    id: "gesicht",
    title: "Gesichtsbehandlungen",
    subtitle: "Pflegerituale für strahlende Haut",
    images: [
      "https://i.postimg.cc/RVwpPMw2/b3c92e43-bd81-4a8f-8601-6b9f8d5a7dcd.jpg",
    ],
    items: [
      { name: "Pro Anti-Aging", price: "85 €" },
      { name: "Regenerierend · Akne", price: "98 €" },
      { name: "Microdermabrasion", price: "75 €" },
      { name: "Fruchtsäurepeeling", price: "95 €" },
      { name: "Problemhaut / Unreine Haut", price: "98 €" },
      { name: "Klassische Gesichtsbehandlung", price: "60 €" },
      { name: "Aloe Vera — Feuchtigkeit", price: "60 €" },
      { name: "Glow Peel", price: "80 €" },
      { name: "Hautanalyse", price: "20 €" },
    ],
  },
  {
    id: "koerper",
    title: "Körperbehandlungen",
    subtitle: "Wohlbefinden von Kopf bis Fuß",
    images: [
      "https://i.postimg.cc/x1vrbvsZ/4eda5fd6-a9cb-40c5-ad1b-18f0c5f08f90.jpg",
    ],
    items: [
      { name: "Körperbehandlung — Akne", price: "60 €" },
      { name: "Körperbehandlung — Rücken", price: "40 €" },
      { name: "Ohrkerzenbehandlung", price: "25 €" },
      { name: "Waxing Gesicht · Achsel · Arme · Beine", price: "20 €" },
      { name: "Vitamin C Infusion", price: "50 €" },
      { name: "Vitamin B12 Infusion", price: "50 €" },
    ],
  },
  {
    id: "haar",
    title: "Haarentfernung · Waxing",
    subtitle: "Sanfte Enthaarung mit Premium-Wachs",
    images: [
      "https://i.postimg.cc/1RrNM2fv/e154ab68-8ad2-4ab5-be17-1a486311d9a0.jpg",
    ],
    items: [
      { name: "Waxing — Gesicht komplett", price: "35 €" },
      { name: "Waxing — Oberlippe", price: "10 €" },
      { name: "Waxing — Kinn", price: "10 €" },
      { name: "Waxing — Ohren", price: "10 €" },
      { name: "Waxing — Schultern", price: "35 €" },
    ],
  },
  {
    id: "naegel",
    title: "Nägel, Hände & Füße",
    subtitle: "Maniküre · Pediküre · Modellage",
    images: [
      "https://i.postimg.cc/FsvVH0L4/f6dfaeaf-9a16-4b54-8c6c-5eae7c23c90b.jpg",
      "https://i.postimg.cc/nztCGGZL/a1f4e2ac-8c70-4c10-9acb-ed8336c3fe94.jpg",
    ],
    items: [
      { name: "Maniküre ohne Lack", price: "25 €" },
      { name: "Maniküre mit Lack", price: "28 €" },
      { name: "Maniküre mit Gellack / Shellac", price: "38 €" },
      { name: "Maniküre mit Paraffinbad", price: "40 €" },
      { name: "Pediküre", price: "40 €" },
      { name: "Pediküre mit Lack", price: "38 €" },
      { name: "Pediküre mit Gellack / Shellac", price: "48 €" },
      { name: "Nagelmodellage — Neues Set Pulver Gel", price: "60 €" },
      { name: "Nagelmodellage — Auffüllen mit Acryl", price: "38 €" },
      { name: "Nagelmodellage — Auffüllen mit Gel", price: "38 €" },
      { name: "Nagelmodellage — Entfernen + Maniküre", price: "25 €" },
      { name: "Naturnagelverstärkung", price: "38 €" },
      { name: "Naturnagelverstärkung inkl. Maniküre", price: "38 €" },
      { name: "Nagelmodellage", price: "ab 38 €" },
      { name: "Baby Boomer Auffüllen", price: "45 €" },
      { name: "Airbrush Nails Auffüllen", price: "45 €" },
      { name: "Nagelreparatur bei Gelmodellage", price: "12 €" },
      { name: "Nagellack-Entfernung Hände oder Füße", price: "2,50 €" },
    ],
  },
  {
    id: "wimpern",
    title: "Wimpern & Augenbrauen",
    subtitle: "Eyes that speak",
    images: [
      "https://i.postimg.cc/JzPqgtth/55c11848-d158-40ae-9382-cfae4c98ed16.jpg",
    ],
    items: [
      { name: "Wimpernverlängerung — Neuanlage 1:1", price: "70 €" },
      { name: "Wimpernverlängerung — Neuanlage 2D", price: "85 €" },
      { name: "Wimpern Refill", price: "ab 45 €" },
      { name: "Wimpernlifting", price: "ab 43 €" },
      { name: "Wimpern färben", price: "8 €" },
      { name: "Augenbrauen", price: "ab 8 €" },
      { name: "Augenbrauen zupfen", price: "6 €" },
      { name: "Augenbrauenkorrektur", price: "8 €" },
      { name: "Augenbrauenlifting", price: "ab 38 €" },
      { name: "Augenbrauen & Wimpern färben", price: "16 €" },
    ],
  },
];

// Hair salon services (own dedicated page)
export const HAIR_CATEGORIES = [
  {
    id: "damen",
    title: "Damen",
    subtitle: "Schnitt · Farbe · Pflege · Styling",
    badge: "Signature",
    items: [
      { name: "Trockenschnitt", price: "ab 30 €" },
      { name: "Waschen · Schneiden · Trocknen", price: "ab 35 €" },
      { name: "Waschen · Schneiden · Föhnen", price: "ab 55 €" },
      { name: "Färben inkl. Pflege", price: "ab 40 €" },
      { name: "Tönen inkl. Pflege", price: "ab 30 €" },
      { name: "Strähnen Halbkopf inkl. Pflege", price: "ab 90 €" },
      { name: "Strähnen Ganzkopf inkl. Pflege", price: "ab 130 €" },
      { name: "Paar Folien", price: "ca. 15 €" },
      { name: "Keratin-Behandlung · Kurz (Haarglättung)", price: "ca. 300 €" },
      { name: "Keratin-Behandlung · Mittel", price: "ca. 400 €" },
      { name: "Keratin-Behandlung · Lang", price: "ca. 500 €" },
      { name: "Ohrenwachsreinigung", price: "18 €" },
      { name: "Wimpern färben", price: "8,50 €" },
      { name: "Augenbrauen färben", price: "8,50 €" },
      { name: "Augenbrauen zupfen", price: "8 €" },
      { name: "Braut-Frisur inkl. Make-up", price: "ab 80 €" },
    ],
  },
  {
    id: "herren",
    title: "Herren",
    subtitle: "Cut · Style · Routine",
    items: [
      { name: "Trockenschnitt", price: "ab 28 €" },
      { name: "Waschen · Schneiden · Stylen", price: "ab 30 €" },
    ],
  },
  {
    id: "kinder",
    title: "Kinder",
    subtitle: "Kleine Gäste, große Sorgfalt",
    items: [
      { name: "Schneiden bis 5 Jahre", price: "bis 14 €" },
      { name: "Schneiden inkl. Stylen", price: "ab 14 €" },
    ],
  },
];

export const IMAGES = {
  hair_hero: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  // Dedicated service category visuals
  pkg_offers: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  injection: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  facial_mask: "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  body_massage: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  waxing: "https://images.unsplash.com/photo-1611080541599-8c6dbde6ed28?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  nails: "https://images.unsplash.com/photo-1604654894610-df63bc536371?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  lashes: "https://images.unsplash.com/photo-1583241800698-e8ab01830a07?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  hero: "https://images.unsplash.com/photo-1763677594421-f58e50cce64d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHx3b21hbiUyMGZsYXdsZXNzJTIwc2tpbiUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3ODU4NTA0OXww&ixlib=rb-4.1.0&q=85",
  facial: "https://images.unsplash.com/photo-1775642548902-2f60a0aa1405?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxmYWNpYWwlMjB0cmVhdG1lbnQlMjBtYXNrJTIwZGFya3xlbnwwfHx8fDE3Nzg1ODUwNTV8MA&ixlib=rb-4.1.0&q=85",
  aesthetic: "https://images.unsplash.com/photo-1695048994291-2e96839a0a3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHx3b21hbiUyMGZsYXdsZXNzJTIwc2tpbiUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3ODU4NTA0OXww&ixlib=rb-4.1.0&q=85",
  interior: "https://i.postimg.cc/3x1TcjgW/a9a455e5-0a61-4c47-ab16-dd6d8e1caac7.jpg",
  texture: "https://images.unsplash.com/photo-1761437855598-011cf89b2ad4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxibGFjayUyMGFuZCUyMGdvbGQlMjBsdXh1cnklMjB0ZXh0dXJlfGVufDB8fHx8MTc3ODU4NTA1NXww&ixlib=rb-4.1.0&q=85",
};
